import waseminari from "../assets/waseminari.png";
import hailmary from "../assets/hailmary.png";
import student from "../assets/student.png";
import hailmary3 from "../assets/hailmary3.png";
import Rector from "../assets/fr-tairo.jpg";
import Ngumba from "../assets/fr-ngumba.png";
import Kasembo from "../assets/fr-kasembo.png";
import visigalogo   from "../assets/visigalogo2.png";
import jesus from "../assets/jesus.png";
import dispensary from "../assets/dispensary.png";
import basketball from "../assets/basketball.png";
import football from "../assets/football.png";
import basketball1 from "../assets/basketball1.png";
import basketball3 from "../assets/basketball3.png";
import ball from "../assets/ball.png";
import askofu from "../assets/askofu.png";
import Askofu from "../assets/askofu3.png";
import hailmary2 from "../assets/hailmary6.png";
import cathedral from "../assets/cathedral.png";
import visiga1 from "../assets/visiga1.png";
import visiga2 from "../assets/visiga2.jpg";
import visiga3 from "../assets/visiga3.jpg";
import visiga4 from "../assets/visiga4.jpg";
import visiga5 from "../assets/visiga5.png";
import visiga6 from "../assets/visiga6.png";
import visiga7 from "../assets/visiga7.jpg";
import visiga8 from "../assets/visiga8.jpg";
import visiga9 from "../assets/visiga9.png";
import visiga10 from "../assets/visiga10.jpg";
import visiga11 from "../assets/visiga11.jpg";
import Milk2 from "../assets/milk2.png";
import Milk3 from "../assets/milk3.png";
import askofumsaidizi from "../assets/askofumsaidizi.png";
import wine1 from "../assets/wine1.png";
import wine2 from "../assets/wine2.png";
import wine3 from "../assets/wine3.png";
import wine4 from "../assets/wine4.png";
import wine5 from "../assets/wine5.png";
import wawata from "../assets/wawata.png";
import bg from  "../assets/bg.png";
import alex from "../assets/alex.png";
import priest from "../assets/priest.png";
import mamamaria2 from "../assets/mamamaria2.png";
import VisigaChurch from "../assets/VisigaChurch.png";
import Hailmary4 from "../assets/hailmary4.png";
import wawata1 from "../assets/wawata1.png";
import wawata2 from "../assets/wawata2.png";
import wawata3 from "../assets/wawata3.png";
import stjoseph from "../assets/stjoseph.jpg";
import bishoplogo from "../assets/bishop-logo.jpg";
import student2 from "../assets/student2.png";
import student3 from "../assets/student3.jpg";
import student4 from "../assets/student4.jpg";
import cleaness from "../assets/cleaness.jpg";
import landscaping from "../assets/landscaping.jpg";
import gardening from "../assets/gardening.jpg";
import livestock1 from "../assets/livestock1.jpg";
import livestock2 from "../assets/livestock2.jpg";





export const images = {
  cleaness,
  landscaping,
  gardening,
  livestock1,
  livestock2,
  waseminari,
  bishoplogo,
  student2,
  student3,
  student4,
  stjoseph,
  wawata1,
  wawata2,
  wawata3,
  hailmary,
  Hailmary4,
  student,
  mamamaria2,
  hailmary3,
  VisigaChurch,
  Rector,
  priest,
  Ngumba,
  alex,
  Kasembo,
  visigalogo,
  jesus,
  dispensary,
  basketball,
  football,
  basketball1,
  basketball3,
  ball,
  askofu,
  Askofu,
  hailmary2,
  cathedral,
  visiga1,
  visiga2,
  visiga3,
  visiga4,
  visiga5,
  visiga6,
  visiga7,
  visiga8,
  visiga9,
  visiga10,
  visiga11,
  Milk2,
  Milk3,
  askofumsaidizi,
  wine1,
  wine2,
  wine3,
  wine4,
  wine5,
  wawata,
  bg
 
};







 
export const platformLinks = [
  {  text: "St Mary's Junior Seminary Visiga" },
  {  text: "Visiga / morogoro-Road / Coast-Region" },
  {  text: "P.O. Box 167   Dar-es-salaam/Tanzania" },
  { text: "Phone: +255 762 457288  " },
  { text: "Phone: +255 655 330260"},
  { text: "email" },
  { text: "st.mary_seminary@yahoo.com" },
];



